import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrder } from '../client/queries'
import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

export const useReorderFiles = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrder({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
